/* globals angular */
// Formata CPF (11 dígitos) ou CNPJ (12 alfanuméricos + 2 dígitos verificadores).
// IN RFB nº 2.229/2024 permite letras [A-Z] nas 12 primeiras posições do CNPJ
// a partir de julho/2026, então substituímos o filtro brCnpj do angular-br-filters,
// que assume apenas dígitos.
function sanitize(value) {
  return (value || '').toString().replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}

function formatCpfCnpj(value) {
  var clean = sanitize(value);

  if (clean.length === 11) {
    return clean.substr(0, 3) + '.' + clean.substr(3, 3) + '.' +
      clean.substr(6, 3) + '-' + clean.substr(9, 2);
  }

  if (clean.length === 14) {
    return clean.substr(0, 2) + '.' + clean.substr(2, 3) + '.' +
      clean.substr(5, 3) + '/' + clean.substr(8, 4) + '-' + clean.substr(12, 2);
  }

  return value || '';
}

angular
  .module('mandaeApp')
  .filter('document', function() {
    'use strict';
    return formatCpfCnpj;
  })
  .filter('cpfCnpj', function() {
    'use strict';
    return formatCpfCnpj;
  });
